var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYoutubeinline = function SvgYoutubeinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10Zm-2.38-5.305 2.668.051c.004 0 .013 0 .013.007 1.485.03 2.932-.063 4.413-.177 1.182-.088 1.462-.995 1.609-2.077.182-1.307.222-2.63.127-3.946l-.014-.189c-.089-1.259-.189-2.674-1.595-2.935a5.913 5.913 0 0 0-.908-.114c-2.873-.099-5.771-.124-8.65.087-.853.059-1.405.593-1.545 1.49a20.693 20.693 0 0 0-.163 4.904c.094 1.133.204 2.456 1.47 2.73.681.15 1.375.156 2.07.162.169.002.337.003.506.007Zm2.484-3.53-1.384.842V7.969c.512.31 1.02.62 1.529.93l1.792 1.089c-.649.393-1.292.784-1.937 1.177Z",
    fill: "#BEB9D7"
  })));
};
export default SvgYoutubeinline;